export default __webpack_public_path__ + "static/media/bgContainer.ed00be17.png";